import echarts from "echarts";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Card from "../../../components/Cards/Card";
import Overlay from "../../../components/Overlay/Overlay";
import Modal from "../../../components/Modal/Modal";
import BarChart from "../../../components/Charts/BarChart";
import LineChart from "../../../components/Charts/LineChart";
import Venn from "../../../components/Charts/Venn";
import VariacoesOverview from "../../../components/VariacoesOverview/VariacoesOverview";
import appearance from "../../../components/Charts/Appearance";
import NativeObject from "../../../components/NativeObject/NativeObject";

function DetailMobile({ app, config }) {
  const { cards } = config.performanceDetail;
  const { title, tooltip, customRadio, legends, comboCharts } = cards[0];

  return (
    <div className="app investments">
      <div className="appContent">
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <Card
            exportTable
            app={app}
            exportTableId="f7e67468-63da-4bc6-be90-850184cdcc40"
            header={{
              hardTitle: "Performance Geral",
              tooltip:
                "Em performance geral, temos a visão unificada dos 3 KPI's do canal (Sell out, Cobertura Total e Cobertura Qualificada) da Meta vs Realizado, por regional e por distribuidor",
            }}
            style={{ width: "100%", height: "500px", alignItems: "center" }}
          >
            <NativeObject
              app={app}
              key="f7e67468-63da-4bc6-be90-850184cdcc40"
              reference={{ id: "f7e67468-63da-4bc6-be90-850184cdcc40" }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>
      </div>
    </div>
  );
}

DetailMobile.defaultProps = {
  app: null,
  config: {},
};

DetailMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DetailMobile;
